import { useFetch } from "~vue/api";
import type { PerformanceReviewRelationship } from "~vue/types/performance_management";

/**
 * A reviewer's review team, each relationship carrying its HRIS provenance: whether the reviewee
 * was seeded from the reporting line, and whether they are a later addition still awaiting the
 * manager's confirmation. One team serves every moment, so neither flag is moment-scoped.
 */
export const usePerformanceReviewRelationships = () => {
    const fetchUrl = "/api/coach/performance_reviews/relationships/";
    return useFetch(fetchUrl, { refetch: true }).get().json<{ relationships: Array<PerformanceReviewRelationship> }>();
};
